import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_bank_recon_events_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	hdr_guid: fromDatatype.GuidDataFieldInterface;
	txn_type: fromDatatype.VarcharDatatypeInterface;
	action: fromDatatype.VarcharDatatypeInterface;
	descr: fromDatatype.VarcharDatatypeInterface;
	message_json: fromDatatype.JsonDatatypeInterface;
	event_code: fromDatatype.VarcharDatatypeInterface;
	date_created: fromDatatype.TimestampTzDatatypeInterface;
	date_completed: fromDatatype.TimestampTzDatatypeInterface;
	date_txn: fromDatatype.TimestampTzDatatypeInterface;
	id_user: fromDatatype.VarcharDatatypeInterface;
	id_device: fromDatatype.VarcharDatatypeInterface;
	id_user_agent: fromDatatype.VarcharDatatypeInterface;
	foreign_table: fromDatatype.VarcharDatatypeInterface;
	foreign_key: fromDatatype.VarcharDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
}


export class bl_fi_bank_recon_events_RowClass implements bl_fi_bank_recon_events_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	hdr_guid: fromDatatype.GuidDataFieldInterface;
	txn_type: fromDatatype.VarcharDatatypeInterface;
	action: fromDatatype.VarcharDatatypeInterface;
	descr: fromDatatype.VarcharDatatypeInterface;
	message_json: fromDatatype.JsonDatatypeInterface;
	event_code: fromDatatype.VarcharDatatypeInterface;
	date_created: fromDatatype.TimestampTzDatatypeInterface;
	date_completed: fromDatatype.TimestampTzDatatypeInterface;
	date_txn: fromDatatype.TimestampTzDatatypeInterface;
	id_user: fromDatatype.VarcharDatatypeInterface;
	id_device: fromDatatype.VarcharDatatypeInterface;
	id_user_agent: fromDatatype.VarcharDatatypeInterface;
	foreign_table: fromDatatype.VarcharDatatypeInterface;
	foreign_key: fromDatatype.VarcharDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.VarcharDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
}

